import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
import user from './modules/user'
import routes from './modules/routes'
import settings from './modules/settings'
import getters from './getters'

var state = {

}

const store = new Vuex.Store({
  modules: {
    user,
    routes,
    settings
  },
  state: state, // 这里放全局参数
  getters
})

export default store
